import { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  IconButton,
  useTheme,
  useMediaQuery,
  Paper,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import QRCode from 'qrcode';
import { routes } from '../config';

export default function CouponDetail() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const navigate = useNavigate();
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState('');

  // Hard-coded random value for QR code
  const qrCodeValue = 'COUPON_20CASH_7K9X2M4P8Q1R3T5V7W9Y0Z';

  useEffect(() => {
    // Generate QR code when component mounts
    QRCode.toDataURL(qrCodeValue, {
      width: 200,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF',
      },
    })
      .then(url => {
        setQrCodeDataUrl(url);
      })
      .catch(err => {
        console.error('Error generating QR code:', err);
      });
  }, []);

  const handleBack = () => {
    navigate(routes.home);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#F8F9FA',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2,
          backgroundColor: 'white',
          borderBottom: '1px solid #E0E0E0',
        }}
      >
        <IconButton onClick={handleBack}>
          <ArrowBack />
        </IconButton>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Typography
            variant="body2"
            sx={{
              borderColor: '#A9C191',
              color: '#A9C191',
              borderRadius: '16px',
              fontSize: '12px',
              px: 1,
              py: 0.5,
              border: '1px solid #A9C191',
            }}
          >
            EN
          </Typography>
        </Box>
      </Box>

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          p: isDesktop ? 4 : 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Offer Title */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            color: '#A9C191',
            textAlign: 'center',
            mb: 3,
            fontSize: isDesktop ? '28px' : '24px',
            lineHeight: 1.2,
          }}
        >
          Welcome Offer $20 Cash<br />
          Coupon
        </Typography>

        {/* Gift Box Illustration */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 4,
            height: isDesktop ? '200px' : '180px',
          }}
        >
          <img
            src="/images/img_giveaway.svg"
            alt="Gift Box"
            style={{
              height: '100%',
              width: 'auto',
              maxWidth: '100%',
            }}
          />
        </Box>

        {/* Details Section */}
        <Box sx={{ width: '100%', maxWidth: '400px' }}>
          {/* Details Header */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 2,
            }}
          >
            <Box
              sx={{
                width: '4px',
                height: '20px',
                backgroundColor: '#A9C191',
                borderRadius: '2px',
                mr: 1,
              }}
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: '#333',
              }}
            >
              Details
            </Typography>
          </Box>

          {/* Redemption Card */}
          <Paper
            elevation={0}
            sx={{
              backgroundColor: 'white',
              borderRadius: '12px',
              p: 3,
              justifyItems: 'center',
              border: '1px solid #E0E0E0',
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                color: '#333',
                fontSize: '20px',
                mb: 1,
              }}
            >
              Show it to our staff
            </Typography>
            <Typography
              sx={{
                color: '#94AF79',
                mb: 3,
                fontSize: '14px',
              }}
            >
              To redeem the reward
            </Typography>

            {/* QR Code */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mb: 3,
                p: 2,
                borderRadius: '8px',
              }}
            >
              {qrCodeDataUrl ? (
                <img
                  src={qrCodeDataUrl}
                  alt="QR Code"
                  style={{
                    width: '200px',
                    height: '200px',
                    borderRadius: '8px',
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: '200px',
                    height: '200px',
                    backgroundColor: '#E0E0E0',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#999',
                      textAlign: 'center',
                    }}
                  >
                    Loading QR Code...
                  </Typography>
                </Box>
              )}
            </Box>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
}
